import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Tape } from "@/components/landing/Tape";
import { Metodo } from "@/components/landing/Metodo";
import { Settori } from "@/components/landing/Settori";
import { Fedelta } from "@/components/landing/Fedelta";
import { Faq } from "@/components/landing/Faq";
import { Contatto } from "@/components/landing/Contatto";
import { StickyBar } from "@/components/landing/StickyBar";
import { Footer } from "@/components/landing/Footer";
import { AuthCallback } from "@/components/admin/AuthCallback";
import AdminArea from "@/components/admin/AdminArea";

const LandingPage = () => (
  <div
    data-testid="landing-page"
    className="bg-[#F6F5F2] text-[#1C1B1A] font-editorial antialiased min-h-screen"
  >
    <Nav />
    <main>
      <Hero />
      <Tape />
      <Metodo />
      <Settori />
      <Fedelta />
      <Faq />
      <Contatto />
    </main>
    <StickyBar />
    <Footer />
  </div>
);

function AppRouter() {
  const location = useLocation();
  // Check URL fragment synchronously during render (prevents race conditions with ProtectedRoute)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin" element={<AdminArea />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
